module.exports = __webpack_public_path__ + "img/flavor7.d92a86e9.svg";